module.exports = __webpack_public_path__ + "static/img/sy_bt_hlj.38d67a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy_bt_hlj.png
// module id = +x2z
// module chunks = 181